export function getPointer(graph, id) {
  if (id && typeof id !== 'string') {
    return graph.node(id);
  }

  if (!id || id.startsWith('_:')) {
    return graph.blankNode();
  }

  return graph.namedNode(id);
}
export function fromInitializer(resource, initializer) {
  const term = getPointer(resource.pointer, initializer.id);
  return resource._create(term, [], {
    initializer
  });
}